export default __webpack_public_path__ + "static/media/emailFilled.2965b731.svg";